import { AfterViewInit, ChangeDetectorRef, Component, effect, HostBinding, inject, input, TemplateRef, viewChild } from '@angular/core';
import { Router } from '@angular/router';

import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../../environments/environment';
import { AppService } from '../../app.service';
import { CoreService } from '../../core/core.service';
import { EnvironmentService } from '../../core/environment.service';
import { ModalService } from '../../core/services/modal.service';
import { LayoutService } from '../../layout/layout.service';
import { LoadingOverlayService } from '../../loading-overlay/loading-overlay.service';
import { CostcentertreeService } from '../../mwsp/shared/costcentertree/costcentertree.service';
import { ICostcenter, IVariant } from '../../mwsp/shared/models/basic.model';

@Component({
    selector: 'oc-navbar',
    templateUrl: './oc-navbar.component.html',
    styles: [':host { display: block; }'],
    standalone: false,
})
export class OcNavbarComponent implements AfterViewInit {
    private appService = inject(AppService);
    private layoutService = inject(LayoutService);
    private router = inject(Router);
    coreService = inject(CoreService);
    private costcentertreeService = inject(CostcentertreeService);
    environmentService = inject(EnvironmentService);
    loadingOverlayService = inject(LoadingOverlayService);
    private modalService = inject(ModalService);
    cdr = inject(ChangeDetectorRef);

    readonly informationModal = viewChild<TemplateRef<any>>('informationModal');
    readonly costcenterModal = viewChild<TemplateRef<any>>('costcenterModal');

    readonly sidenavToggle = input(true);

    @HostBinding('class.navbar') private hostClassMain = true;

    isExpanded = false;
    isRTL: boolean;
    costcenterModalHeadline: string = 'Anmeldung für Kostenstelle:';

    currentUserCostcenter: ICostcenter;
    currentUserCostcenterName: string = '';

    fontsizes: number[] = [24, 16, 14, 12];

    themes = [
        {
            name: 'theme-orgacard',
            desc: 'OC-DefaultTheme',
            selected: null,
            preview: {
                color1: '#144263',
                color2: '#fbf6e4',
                color3: '#1c2f40',
            },
        },
        {
            name: 'theme-oc-disabilityaccess',
            desc: 'OC-DA',
            selected: null,
            preview: {
                color1: '',
                color2: '',
                color3: '',
            },
        },
    ];

    env = environment;
    info: string =
        this.coreService.getMsgkey('mws.information.applicationname', undefined) +
        ': ' +
        this.environmentService.versionData.backendname +
        '\n' +
        this.coreService.getMsgkey('mws.information.version.frontend', undefined) +
        ': ' +
        this.env.version +
        '\n' +
        this.coreService.getMsgkey('mws.information.version.backend', undefined) +
        ': ' +
        this.environmentService.versionData.backendversion +
        '\n' +
        this.coreService.getMsgkey('mws.information.version.support', undefined) +
        ': ' +
        this.coreService.getMsgkey('mws.information.version.support.link', undefined);

    constructor() {
        const appService = this.appService;

        this.isRTL = appService.isRTL;

        effect(() => {
            this.environmentService.userCostcenterTreeSignal();
            this.fillAttributes();
        });
    }

    ngAfterViewInit(): void {
        // console.log('ngOnInit');
        this.fillAttributes();
    }

    currentBg() {
        return `bg-${this.appService.layoutNavbarBg}`;
    }

    getDropdownPlacement(): string {
        if (window.innerWidth <= 768) {
            // 768px ist der typische Breakpoint für mobile Geräte
            return '';
        }
        return '';
    }

    toggleSidenav() {
        const layoutWrapper = document.querySelector('#wrapper');
        if (layoutWrapper) {
            if (window.innerWidth > 768) {
                layoutWrapper.classList.toggle('sidenav-minimized');
            } else {
                layoutWrapper.classList.toggle('sidenav-visible');
            }
        }
    }

    fillAttributes() {
        this.currentUserCostcenter = this.costcentertreeService.findCostcenterById(
            this.environmentService.userCostcenterTree,
            this.environmentService.currentUserCostcenterId,
        );
        if (this.currentUserCostcenter) {
            this.currentUserCostcenterName = this.currentUserCostcenter.costcenterNumber + ' - ' + this.currentUserCostcenter.description;
        } else {
            this.currentUserCostcenterName = this.coreService.getMsgkey('mws.navbar.nousercostcenter', undefined);
        }
    }

    toSettings() {
        this.router.navigate(['konto']);
    }

    logout() {
        this.environmentService.init();
        localStorage.removeItem('loggedInUser');
        this.router.navigate(['/']);
    }

    showInformation() {
        const options: NgbModalOptions = { centered: false, backdrop: 'static', windowClass: 'modal-lg animate' };

        this.modalService.openModal(this.informationModal(), options);
    }

    openCostcenterModal() {
        const currentUserCostcenter = this.costcentertreeService.findCostcenterById(
            this.environmentService.userCostcenterTree,
            this.environmentService.currentUserCostcenterId,
        );
        currentUserCostcenter.selected = true;

        const options: NgbModalOptions = { centered: true, backdrop: 'static' };
        this.modalService.openModal(this.costcenterModal(), options);
    }

    cancelCostcenter() {
        this.modalService.closeAllModals();
    }

    checkCurrentUserCostcenter(costcenter: ICostcenter) {
        // 1) vorher SELECTED Kostenstelle zurücksetzen
        const currentUserCostcenterOLD = this.costcentertreeService.findCostcenterById(
            this.environmentService.userCostcenterTree,
            this.environmentService.currentUserCostcenterId,
        );
        currentUserCostcenterOLD.selected = false;
        // 2) aktuelle Werte eintragen
        this.environmentService.currentUserCostcenterId = costcenter.id;
        this.currentUserCostcenterName = costcenter.name;
        // 3) aktuelle Kostenstelle markieren
        const currentUserCostcenter = this.costcentertreeService.findCostcenterById(this.environmentService.userCostcenterTree, costcenter.id);
        currentUserCostcenter.selected = true;
        // 4) aktualisierten Kostenstellebaum auch in die TreeNodes stellen
        this.environmentService.userCostcenterTreeNodes = [this.environmentService.userCostcenterTree];
        //this.environmentService.userCostcenterTreeNodes.push(this.environmentService.userCostcenterTree);
        // 5) Naviation auf HOME
        // const routerUrl = this.router.url;
        // this.router.navigate([routerUrl]);
        this.router.navigate(['/mwsp/home']);

        this.modalService.closeAllModals();
    }

    setLanguage(variant: IVariant) {
        // console.log(variant);
        this.environmentService.appSettings.locale = variant.variant;
        this.cdr.detectChanges();
    }
}
